<script>
export default {
    props: [
     'canxError',
     'canxSuccess',
    ]
}
</script>
<template>
    <div>
        <div class="row-fluid">
            <p v-if="canxError.canxError" class="m-auto text-danger">We're sorry we are unable to process this request. Please contact your travel consultant.</p>
        </div>
        <div class="row-fluid">
            <p v-if="canxSuccess.canxSuccess">Thank you. We're sorry you are cancelling but we will send you confirmation and further information in an email shortly.</p>
        </div>

    </div>

</template>